import { render } from "./RegisterInsuranceCompanies.vue?vue&type=template&id=447b3d4d"
import script from "./RegisterInsuranceCompanies.vue?vue&type=script&lang=js"
export * from "./RegisterInsuranceCompanies.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__